<template>
  <card header-classes="mb-0">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-12">
        <el-form ref="form" :model="form" label-width="150px">
          <el-form-item label="Old Password">
            <el-input v-model="form.oldPassword" show-password></el-input>
          </el-form-item>
          <el-form-item label="New Password">
            <el-input v-model="form.newPassword" show-password></el-input>
          </el-form-item>
          <el-form-item label="Confirm Password">
            <el-input v-model="form.confirmPassword" show-password></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div
      slot="footer"
      class="col-12 justify-content-center flex-wrap text-right"
    >
      <div class="row justify-content-center">
        <div class="col-lg-6 col-12">
          <el-button @click="changePasswordButton" size="mini" type="primary"
            >Submit</el-button
          >
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import { Form, FormItem, Input, Button, Loading } from "element-ui";
import api from "./api";
import Swal from "sweetalert2";
import auth from "../../util/auth";

export default {
  components: {
    [Button.name]: Button,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Loading.name]: Loading,
  },
  data() {
    return {
      captchaImage: null,
      msg: null,
      labelPosition: "left",
      form: {
        oldPassword: null,
        newPassword: null,
        confirmPassword: null,
      },
    };
  },
  methods: {
    async changePasswordButton() {
      let loadprg = Loading.service({
        fullscreen: true,
        lock: true,
        text: "Loading ...",
        spinner: "el-icon-loading",
      });
      // Check old password form database
      let userIdLogin = auth.getUserApp().USER_ID;
      let passwordFromDb = await api.getOldPassword(userIdLogin);
      if (passwordFromDb.data[0].LOGIN_PASSWORD == this.form.oldPassword) {
        // Compare New and confirm password
        if (
          this.form.newPassword == this.form.confirmPassword &&
          this.form.confirmPassword != null
        ) {
          let newPasswordData = {
            LOGIN_PASSWORD: this.form.newPassword,
            USER_ID: userIdLogin,
          };
          // Execution
          Swal.fire({
            title: "Apakah anda yakin mengubah password?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
          }).then((result) => {
            if (result.isConfirmed) {
              api.changePasswordCustomer(newPasswordData);
              Swal.fire("Telah diubah!", "", "success");
              this.$router.push({
                path: "/buat-pengajuan",
              });
              loadprg.close();
            }
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Wait",
            text: "Password yang baru dengan confirmasi tidak boleh kosong dan harus sama!",
          });
          loadprg.close();
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Wait",
          text: "Password lama anda salah!",
        });
        loadprg.close();
      }
    },
  },
  computed: {},
};
</script>
